import React from 'react';

import { schemas } from '@/network/client';

import { StaticContentItem } from './components/StaticContentItem';

interface Props {
  content: schemas['Description'];
}

const getSide = (itemsCount = 0, index: number) => {
  if (itemsCount < 2) {
    return undefined;
  }
  if (index === 0) {
    return 'left';
  }
  return 'right';
};

export const StaticContent = (props: Props) => {
  const { content } = props;
  const { sections = [] } = content;

  return (
    <div>
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="flex flex-col laptop:flex-row laptop:items-center">
          {section.items?.map((sectionItem, sectionItemIndex) => (
            <div key={sectionItemIndex} className="my-3 flex-1 basis-0">
              <StaticContentItem data={sectionItem} side={getSide(section.items?.length, sectionItemIndex)} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
